import React from "react";
import { connect } from "react-redux";
import * as actions from "../redux/actions/adFaqActions";
import "./styles/AdFaq.css";
import { FaPaperPlane } from "react-icons/fa";
import { withRouter } from "react-router";
import alertify from "alertifyjs";
import "./styles/Alertify.css";
import "./styles/AlertifyTheme.css";
import "./styles/Alertify.min.css";
import "./styles/AlertifyTheme.min.css";
import { Translate, I18n } from "react-redux-i18n";
import MiniLoader from "./MiniLoader";

class AdFaqListItem extends React.Component {
  render() {
    const { item } = this.props;
    const isAnswered = Boolean(item.Answer && item.Answer.length > 0);

    return (
      <article className="ad-faq-item">
        <div className="ad-faq-item__header">
          <span
            className={`ad-faq-item__status${
              isAnswered
                ? " ad-faq-item__status--answered"
                : " ad-faq-item__status--pending"
            }`}
          >
            {isAnswered ? (
              <Translate value="faq_close" />
            ) : (
              <Translate value="faq_pending" />
            )}
          </span>
          <time className="ad-faq-item__date">{item.CreatedAt}</time>
        </div>

        <div className="ad-faq-item__block">
          <span className="ad-faq-item__label">
            <Translate value="faq_question" />
          </span>
          <p className="ad-faq-item__text">{item.Question}</p>
        </div>

        {isAnswered ? (
          <div className="ad-faq-item__block ad-faq-item__block--answer">
            <span className="ad-faq-item__label">
              <Translate value="faq_answer" />
            </span>
            <p className="ad-faq-item__text">{item.Answer}</p>
          </div>
        ) : (
          <p className="ad-faq-item__pending">
            <Translate value="faq_pending" />
          </p>
        )}
      </article>
    );
  }
}

class AdFaq extends React.Component {
  state = {
    question: "",
  };

  componentDidMount() {
    this.loadFaqIfNeeded();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.ad?.Id !== this.props.ad?.Id) {
      this.loadFaqIfNeeded();
    }
  }

  loadFaqIfNeeded = () => {
    if (!this.props.ad?.Id) {
      return;
    }

    this.props.LoadAdFaq(
      this.props.ad.Id,
      this.props.user_id,
      this.props.token
    );
  };

  onChange = (event) => {
    this.setState({
      question: event.target.value,
    });
  };

  handleSubmit = async (event) => {
    event.preventDefault();

    if (JSON.stringify(this.props.user) === "{}") {
      alertify.alert(
        I18n.t("warning"),
        I18n.t("warning_login"),
        function () {}
      );
      return;
    }

    if (!this.state.question.trim()) {
      return;
    }

    await this.props
      .AddQuestion(
        this.state.question.trim(),
        this.props.ad.Id,
        this.props.user_id,
        this.props.token
      )
      .then(() => {
        if (this.props.error) {
          alertify.warning(I18n.t(this.props.error));
        } else {
          this.setState({
            question: "",
          });
        }
      });
  };

  onClickLoadMore = async () => {
    try {
      await this.props
        .LoadAdFaqMore(
          this.props.pageCount,
          this.props.ad.Id,
          this.props.user_id,
          this.props.token
        )
        .then(() => {
          if (this.props.error) {
            alertify.warning(I18n.t(this.props.error));
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    const { adFaqList, loading } = this.props;
    const hasQuestions = adFaqList && adFaqList.length > 0;

    return (
      <div className="ad-faq">
        <form className="ad-faq-ask" onSubmit={this.handleSubmit}>
          <input
            className="ad-faq-ask__input form-control"
            type="text"
            value={this.state.question}
            onChange={this.onChange}
            name="question"
            placeholder={I18n.t("faq_placeholder")}
          />
          <button
            type="submit"
            className="ad-faq-ask__btn"
            disabled={this.state.question.trim().length === 0}
            aria-label={I18n.t("faq_question")}
          >
            <FaPaperPlane />
          </button>
        </form>

        {loading ? (
          <MiniLoader />
        ) : !hasQuestions ? (
          <div className="ad-faq-empty">
            <Translate value="faq_answer_not_list" />
          </div>
        ) : (
          <div className="ad-faq-list">
            {adFaqList.map((item) => (
              <AdFaqListItem item={item} key={item.Id} />
            ))}
          </div>
        )}

        {this.props.pageSize > 7 &&
          (this.props.loadingMore ? (
            <div className="ad-faq-load-more">
              <MiniLoader />
            </div>
          ) : (
            <div className="ad-faq-load-more">
              <button
                type="button"
                className="ad-faq-load-more-btn"
                onClick={this.onClickLoadMore}
              >
                <Translate value="load_more" />
              </button>
            </div>
          ))}
      </div>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    user: reducer.session.auth,
    adFaqList: reducer.adFaq.list,
    ad: reducer.ad.item,
    error: reducer.adFaq.error,
    loading: reducer.adFaq.loading,
    lang: reducer.i18n.locale,
    pageSize: reducer.adFaq.page_size,
    pageCount: reducer.adFaq.page_count,
    loadingMore: reducer.adFaq.loadingMore,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadAdFaq: (id, user_id, token) =>
    dispatch(actions.loadList({ id, user_id, token })),
  LoadAdFaqMore: (page_count, id, user_id, token) =>
    dispatch(actions.loadListScroll({ page_count, id, user_id, token })),
  AddQuestion: (question, id, user_id, token) =>
    dispatch(actions.newItem({ question, id, user_id, token })),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AdFaq));
